// @flow

export default {};
